<template>
  <div>
    <vue-headful :title="getPageTitle" description="Description goes here" />
    <div
      class="class-video-section base-type-layout"
      :class="account_type === 'school' ? 'school-top' : ''"
    >
      <!-- BREADCRUMB -->
      <div :class="account_type === 'school' ? 'breadcrumb-section' : null">
        <BreadCrumb
          :item_one="current_class_name"
          item_three="Videos"
          :current_page="0"
          :total_page="0"
          :show_nav="false"
          item_two="Library"
          :item_two_link="accountType + 'Library'"
        ></BreadCrumb>
        <!-- BREADCRUMB -->
      </div>

      <div class="container px-1 mt-5">
        <div class="row">
          <!-- CLASS BRANCH INFO COLUMN -->
          <div class="col-12 col-md-3 col-lg-3 left-layout">
            <!-- TEACHER CLASSES COMPONENT -->
            <TeacherClassCard
              v-if="account_type === 'teacher'"
            ></TeacherClassCard>

            <MembersCard
              v-else-if="account_type === 'school'"
              @updateTeacher="num_counter++"
            >
              <!-- LOADER -->
              <div
                class="loader d-flex justify-content-center align-items-center my-4"
                v-if="teacher_count === null"
              >
                <div class="avatar">
                  <span
                    class="icon-dotted-spinner flex-center font-22 border_grey_dark animate mr-2"
                  ></span>
                </div>
                <div class="border_grey_dark font-13">Loading Teachers ...</div>
              </div>
              <!-- LOADER -->

              <div slot="teacher__content" v-else>
                <!-- CONTENT TEACHER LIST -->
                <MembersTeacherRow
                  v-if="teacher_count > 0"
                  :teachers_list="teacher_data"
                  @toggleTeacher="toggleTeacherModal"
                ></MembersTeacherRow>

                <!-- EMPTY TEACHER LIST -->
                <div class="teacher-list-empty mb-3">
                  <MembersEmptyTeacherRow
                    v-if="teacher_count === 0"
                    @toggleTeacher="toggleTeacherModal"
                  ></MembersEmptyTeacherRow>
                </div>
              </div>
            </MembersCard>
            <!-- MEMBERS CARD COMPONENT -->
          </div>
          <!-- CLASS BRANCH INFO COLUMN -->

          <!-- CLASS VIDEOS -->
          <div class="col-12 col-md-9 col-lg-9 right-layout">
            <!-- TITLE ROW -->
            <div
              class="title-row d-flex justify-content-between align-items-center nowrap"
            >
              <!-- TEXT TITLE -->
              <div class="text-title font-weight-bold color_text">
                <router-link
                  :to="{ name: accountType + 'Library' }"
                  class="icon icon-arrow-left color_text font-20 position-relative pointer mr-2 font-weight-400 d-md-none"
                  style="top: 3px"
                  title="Go Back"
                ></router-link>
                Videos
              </div>

              <div>
                <!-- ADD NEW VIDEO -->
                <div
                  v-if="false"
                  class="avatar brand_accent_bg pointer hint--primary hint--rounded hint--bottom"
                  aria-label="Add Video"
                  style="overflow: unset"
                  @click="toggleVideoModal"
                >
                  <span class="icon-plus flex-center color_text font-18"></span>
                </div>
                <!-- ADD NEW VIDEO -->

                <!-- FILTER VIDEO -->
                <div
                  class="avatar brand_primary_bg pointer ml-2"
                  title="Filter Videos"
                  @click="toggleFilterModal"
                >
                  <span
                    class="icon-search flex-center brand_white font-18"
                  ></span>
                </div>
                <!-- FILTER VIDEO -->
              </div>
            </div>

            <!-- FILTER ROW -->
            <div
              class="filter-row d-flex justify-content-between align-items-center nowrap"
            >
              <div class="file-count color_text">
                {{ setFileCount(videoData.length) }}
              </div>
            </div>

            <!-- VIDEO CARD -->
            <div class="row">
              <div
                class="col-6 col-md-4"
                v-for="(video, index) in videoData"
                :key="index"
              >
                <VideoCard
                  :video_poster="video.thumbnail"
                  :video_file="video.filename"
                  :video_title="video.title"
                  :video_date="video.created_at"
                  :video_time="video.created_at"
                  :video_tag="video.tag"
                  :video_token="video.token"
                  :video_user="video.user"
                  :subscription_status="subscription_status"
                ></VideoCard>
              </div>
            </div>
            <!-- VIDEO CARD -->

            <!-- PAGINATION COMPONENT -->
            <div class="container px-1" v-if="videoData.length > 0">
              <div
                class="row d-flex justify-content-start"
                v-if="pagination.pageCount > 1"
              >
                <Pagination
                  :paging="pagination"
                  @navigatePage="navigatePageNum($event)"
                />
              </div>
            </div>
            <!-- PAGINATION COMPONENT -->

            <!-- EMPTY STATE-->
            <div v-if="videoData.length === 0" class style="position: relative">
              <DefaultVideoInfo :is_loading="is_loading" />
              <EmptyContent
                display_img="EmptyStudent.png"
                display_text="There are currently no videos in this class"
                button_type="emit"
                button_text="Upload Video"
                button_function="addVideos"
                @addVideos="toggleVideoModal"
                :show_empty="is_empty_videos"
              />
            </div>
            <!-- EMPTY STATE-->
          </div>
          <!-- CLASS DOCUMENTS -->
        </div>
      </div>

      <!-- MODAL COMPONENTS -->
      <AddTeacherModal
        v-if="teacher_modal"
        @closeTriggered="toggleTeacherModal"
      ></AddTeacherModal>

      <UploadVideoModal
        v-if="video_modal"
        @closeTriggered="toggleVideoModal"
        @uploaded="remountComponent"
      />

      <FilterVideoModal
        v-if="filter_modal"
        @closeTriggered="toggleFilterModal"
        @applyFilters="applyFilters"
      ></FilterVideoModal>
      <!-- MODAL COMPONENTS -->
    </div>
  </div>
</template>

<script>
import {
  capitalizeFirstLetter,
  formatDate,
  formatTime,
} from "@/scripts/utilities";
import BreadCrumb from "@/components/globalComps/BreadCrumb";
import TeachersInClass from "@/scripts/mixins/TeachersInClass";
import MembersCard from "@/components/classComps/studentSideBar/MembersCard";
import MembersEmptyTeacherRow from "@/components/classComps/studentSideBar/MembersEmptyTeacherRow";
import Pagination from "@/components/globalComps/Pagination";
import TeacherClassCard from "@/components/classComps/teacherSideBar/TeacherClassCard";
import EmptyContent from "@/components/globalComps/EmptyContent";
import DefaultVideoInfo from "@/components/classComps/library/DefaultVideoInfo";
import { mapGetters, mapActions } from "vuex";

const MembersTeacherRow = () => ({
  component: import(
    /* webpackChunkName: "MembersTeacherRow" */ "@/components/classComps/studentSideBar/MembersTeacherRow"
  ),
  loading: MembersEmptyTeacherRow,
  error: MembersEmptyTeacherRow,
  delay: 300,
  timeout: 7000,
});

export default {
  name: "Videos",

  components: {
    BreadCrumb,
    MembersCard,
    MembersEmptyTeacherRow,
    MembersTeacherRow,
    Pagination,
    TeacherClassCard,
    EmptyContent,
    DefaultVideoInfo,

    VideoCard: () =>
      import(
        /* webpackChunkName: "VideoCard" */ "@/components/classComps/library/VideoCard"
      ),
    UploadVideoModal: () =>
      import(
        /* webpackChunkName: "UploadVideoModal" */ "@/components/modalComps/classModals/UploadVideoModal"
      ),
    FilterVideoModal: () =>
      import(
        /* webpackChunkName: "FilterDocumentModal" */ "@/components/modalComps/classModals/FilterVideoModal"
      ),
    AddTeacherModal: () =>
      import(
        /* webpackChunkName: "AddTeacherModal" */ "@/components/modalComps/schoolModals/AddTeacherModal"
      ),
  },

  mixins: [TeachersInClass],

  computed: {
    ...mapGetters(["getCurrentClass"]),

    accountType() {
      if (this.account_type === "school") return capitalizeFirstLetter("class");
      else return capitalizeFirstLetter(this.account_type);
    },

    getPageTitle() {
      return `Class Videos | ${capitalizeFirstLetter(this.account_type)}`;
    },
  },

  data() {
    return {
      account_type: this.$route.path.split("/")[1],
      teacher_modal: false,
      video_modal: false,
      filter_modal: false,

      videoData: [],
      pagination: {
        pageCount: 0,
      },

      is_loading: true,
      is_empty_videos: false,

      sort: null,
      search: null,
      date: null,

      current_class_name: "Class...",
      subscription_status: false,
    };
  },

  watch: {
    $route: {
      handler(newVal) {
        if (newVal) {
          this.getClassName();
          this.clearOutFilters();
          this.getVideos();
          this.callPaymentStatus();
        }
      },
      immediate: true, // make this watch function is called when component created
    },
  },

  created() {
    this.getClassName();
  },

  methods: {
    ...mapActions(["getLibraryData", "getSubscriptionPaymentStatus"]),

    callPaymentStatus(child_id = 0, class_id = 0) {
      if (this.account_type === "teacher") {
        this.getSubscriptionPaymentStatus({
          child_id,
          class_id: this.getCurrentClass,
        })
          .then((response) => {
            this.subscription_status = true || response.data.status;
          })
          .catch((err) => console.log(err));
      } else {
        this.getSubscriptionPaymentStatus({ child_id, class_id })
          .then((response) => {
            this.subscription_status = true || response.data.status;
          })
          .catch((err) => console.log(err));
      }
    },

    clearOutFilters() {
      this.sort = null;
      this.format = null;
      this.search = null;
      this.date = null;
    },

    // GET CURRENT CLASS NAME
    async getClassName() {
      // SCHOOL ACCOUNT
      if (this.account_type === "school") {
        let query = await this.$store.dispatch(
          "getSingleClass",
          this.$route.params.id
        );
        this.current_class_name = query.data.class_name;
      }
      // TEACHER ACCOUNT
      else if (this.account_type === "teacher") {
        let query = await this.$store.dispatch(
          "getClassDetailsByID",
          this.$route.params.id
        );
        this.current_class_name = query.data.data.class_name;
      }
    },

    getVideos(page = 1) {
      let url = `/library/video?class_id=${this.$route.params.id}`;

      if (page > 1) url += `&page=${page}`;
      if (this.sort) url += `&sort=${this.sort}`;
      if (this.search) url += `&search=${this.search}`;
      if (this.date) url += `&date=${this.date}`;

      this.videoData = [];
      this.is_empty_videos = false;
      this.is_loading = true;

      setTimeout(() => {
        this.getLibraryData(url)
          .then((response) => {
            console.log(response);
            if (response.data.length > 0) {
              this.videoData = response.data;
              this.pagination = response.pagination;
            } else
              setTimeout(() => {
                this.is_empty_videos = true;
                this.is_loading = false;
              }, 1500);
          })
          .catch((err) => console.log(err));
      }, 300);
    },

    navigatePageNum(page_num) {
      this.getVideos(page_num);
    },

    remountComponent() {
      this.clearOutFilters();
      this.getVideos();
    },

    setFileCount(count) {
      if (count > 1) return `${count} Files`;
      else return `${count} File`;
    },

    toggleVideoModal() {
      this.video_modal = !this.video_modal;
    },

    formatVideoDate(date) {
      return formatDate(date);
    },

    formatVideoTime(date) {
      return formatTime(date);
    },

    toggleFilterModal() {
      this.filter_modal = !this.filter_modal;
    },

    applyFilters(filters) {
      this.sort = filters.sorted_by;
      this.search = filters.search;
      this.date = filters.date;

      this.getVideos();
      this.toggleFilterModal();
    },
  },
};
</script>

<style lang="scss" scoped>
.class-video-section {
  .breadcrumb-section {
    margin-top: 50px;
  }

  .right-layout {
    @include breakpoint_max(lg) {
      padding-left: 30px;
      padding-right: 0px;
    }

    @include breakpoint_max(md) {
      margin-bottom: 80px;
      padding-left: 15px;
      padding-right: 15px;
    }

    .title-row {
      margin-bottom: 40px;

      @include breakpoint_max(sm) {
        margin-bottom: 30px;
      }

      .text-title {
        font-size: 21px;
        line-height: 29px;

        @include breakpoint_max(sm) {
          font-size: 17px;
        }
        @include breakpoint_max(xs) {
          font-size: 16px;
        }
      }

      .avatar {
        @include equal_min_edge(35);
        @include breakpoint_max(sm) {
          @include equal_min_edge(32);
          span {
            font-size: 15px !important;
          }
        }
      }
    }

    .filter-row {
      padding-bottom: 10px;
      margin-bottom: 20px;
      border-bottom: 1px solid $border_grey;

      .file-count,
      .filter {
        font-size: 13px;
        line-height: 16px;

        @include breakpoint_max(sm) {
          font-size: 11.5px;
          line-height: 13px;
        }
      }
    }
  }
}
</style>
